// ----------------------------------------------------------------------
// <copyright file="Izenda.AddUserPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AddUserPopup Component
 */
!(function() {
  require('share/utils/Izenda.StringUtilities');
  var CANCEL_TEXT = 'cancel';
  var ACCEPT_TEXT = 'accept';
  var React = require('react');
  var AddUserGrid = require('./Izenda.AddUserGrid');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var connect = require('share/enhancers/Izenda.Connect');
  var UserAccountStore = require('logic/Izenda.UserAccountStore');
  const { filter, every, forEach, find, isNil } = require('lodash/fp');

  var AddUserPopup = React.createClass({
    propTypes: {
      store: React.PropTypes.object,
      onChange: React.PropTypes.func.isRequired,
      selectedItems: React.PropTypes.array
    },

    componentWillMount: function() {
      this.userAccountStore = new UserAccountStore(this.props.loadUsers, this.props.userModeType);
      this.userAccountStore.onPrePopulateUserAccounts = this.onPrePopulateUserAccounts;
    },

    componentDidMount: function() {
      var loader = this.props.loader;
      loader.startLoading();
      this.userAccountStore.loadAllUserAccounts().finally(loader.endLoading.bind(loader));
    },

    onPrePopulateUserAccounts: function(userAccounts) {
      const { props, props: { selectedItems } } = this;
      forEach(userAccuount => {
        const selectedItem = props.validateEmails
          ? find({ email: userAccuount.emailAddress }, selectedItems)
          : find({ id: userAccuount.id }, selectedItems);
        userAccuount.selected = !isNil(selectedItem);
      }, userAccounts.result);
    },

    /**
     * Handle when popup closing
     * @param  {Object} closeCallback function
     * @param  {Object} type of close button click
     */
    onClosing: function(closeCallback, type) {
      var model = this.userAccountStore.model;
      var props = this.props;
      var userAccountList = model.userAccountList || [];

      var data = filter(function(userAccount) {
        return userAccount.selected;
      }, userAccountList);

      if (type === ACCEPT_TEXT) {
        // Validate selectedUser hasEmail
        if (props.validateEmails && !every('emailAddress', data)) {
          // get error message
          this.userAccountStore.validateEmails(data);
          return;
        }
        props.onChange(data);
        props.onAccept();
      } else if (type === CANCEL_TEXT) {
        props.onReject();
      }
    },

    /**
     * Render component
     * @return {[type]} [description]
     */
    render: function() {
      var localization = this.props.localization;

      return (
        <Popup visible onClosing={this.onClosing} autoClose={false} type="none" sizeClass="modal-lg">
          <Popup.Header title={localization.getText('USER_LABEL_ALL_USERS')} />
          <Popup.Body>
            <AddUserGrid
              store={this.userAccountStore}
              singleUser={this.props.singleUser}
            />
          </Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton type="accept">{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
            <Popup.ConfirmationButton type="cancel">
              {localization.getText('COMMON_LABEL_CANCEL')}
            </Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      );
    }
  });

  module.exports = connect()(AddUserPopup);

  module.exports.$popupName = 'AddUserPopup';
})();



// WEBPACK FOOTER //
// ./ui/modules/User/Izenda.AddUserPopup.jsx